import '@/assets/css/tailwind.scss'
import i18n from '@/i18n/i18n'
import ElementPlus from 'element-plus'
import 'element-plus/lib/theme-chalk/index.css'
import 'reset-css'
import { createApp } from 'vue'
import LeaderLine from 'vue3-leaderline'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import './views/router-hooks'

// disable auto position leader line when windows resize
LeaderLine.positionByWindowResize = false
createApp(App)
  .use(store)
  .use(router)
  .use(i18n)
  .use(ElementPlus, {
    i18n: (key: string) => {
      return i18n.global.t(key)
    },
  })
  .mount('#app')
